import React from 'react';
import { Grid, imageTypes } from 'components';
import SixteenNineItem from 'components/VideoItems/SixteenNineItem';
import RegularItem from 'components/VideoItems/RegularItem';
import { ITEM_MODE } from 'components/VideoItems/constants';
import { ViewableType } from 'types';
import { TooltipTrigger } from 'components/HoverState';

interface ILinkedCollectionViewablesTabProps {
  viewables: ViewableType[],
  is16x9?: boolean,
  collectionId?: string,
}

const LinkedCollectionViewablesTab: React.FC<ILinkedCollectionViewablesTabProps> = (props) => {
  const { viewables, is16x9, collectionId } = props;
  const gridItemWidth = is16x9 ? imageTypes.sixteenNineBanner.width : imageTypes.poster.width;

  const itemMapper = is16x9
    ? (viewable: ViewableType) => (
      <TooltipTrigger
        key={viewable.id}
        viewable={viewable}
        collectionId={collectionId}
      >
        <SixteenNineItem
          hideKind
          hideChannelLogo
          viewable={viewable}
          mode={ITEM_MODE.RELATED}
        />
      </TooltipTrigger>
    )
    : (viewable: ViewableType) => (
      <TooltipTrigger
        key={viewable.id}
        viewable={viewable}
        collectionId={collectionId}
      >
        <RegularItem
          disableLiveInfo
          hideChannelLogo
          viewable={viewable}
          mode={ITEM_MODE.GRID}
        />
      </TooltipTrigger>
    );

  return (
    <Grid itemWidth={gridItemWidth} is16x9={is16x9}>
      {viewables.map(itemMapper)}
    </Grid>
  );
};

export default React.memo(LinkedCollectionViewablesTab);
